import React, { useState, useEffect } from 'react';
import api from '../api';

export default function AddTransaction({ onAdded }) {

  const [raw_label, setRawLabel] = useState('');
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState('');
  const [type, setType] = useState('expense');
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [cashAccountId, setCashAccountId] = useState(1);
  const [bankAccountId, setBankAccountId] = useState(1);
  const [showWithdrawal, setShowWithdrawal] = useState(false);
  const [merchants, setMerchants] = useState([]);
  const [merchantId, setMerchantId] = useState('');

  useEffect(() => {
    api.get('/merchants').then(res => setMerchants(res.data)).catch(() => {});
  }, []);

  const handleMerchantChange = (id) => {
    setMerchantId(id);
    if (id) {
      const m = merchants.find(m => String(m.id) === String(id));
      if (m && !raw_label) setRawLabel(m.name);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const numericAmount = parseFloat(amount);
      if (isNaN(numericAmount)) { alert("Montant invalide"); return; }
      const signedAmount = type === 'expense' ? -Math.abs(numericAmount) : Math.abs(numericAmount);
      await api.post('/transactions', {
        raw_label,
        amount: signedAmount,
        date,
        type,
        payment_method: paymentMethod,
        cash_account_id: paymentMethod === 'cash' ? parseInt(cashAccountId) : null,
        source: 'manual',
        merchant_id: merchantId ? parseInt(merchantId) : undefined
      });
      onAdded?.();
      resetForm();
    } catch (err) {
      console.error(err);
      alert('Erreur ajout transaction');
    }
  };

  const handleWithdrawal = async (e) => {
    e.preventDefault();
    try {
      const numericAmount = parseFloat(amount);
      if (isNaN(numericAmount)) { alert("Montant invalide"); return; }
      await api.post('/transactions/cash-withdrawal', {
        bank_account_id: parseInt(bankAccountId),
        cash_account_id: parseInt(cashAccountId),
        amount: Math.abs(numericAmount),
        date,
        raw_label: raw_label || 'ATM Withdrawal'
      });
      onAdded?.();
      resetForm();
      setShowWithdrawal(false);
    } catch (err) {
      console.error(err);
      alert('Erreur retrait espèces');
    }
  };

  const resetForm = () => {
    setRawLabel(''); setAmount(''); setDate('');
    setType('expense'); setPaymentMethod('card');
    setCashAccountId(1); setBankAccountId(1);
    setMerchantId('');
  };

  return (
    <div>

      {/* TRANSACTION */}
      <form onSubmit={handleSubmit}>

        <div className="form-grid">

          <div className="form-group">
            <label>Type</label>
            <select value={type} onChange={e => setType(e.target.value)}>
              <option value="expense">Dépense</option>
              <option value="income">Revenu</option>
            </select>
          </div>

          <div className="form-group">
            <label>Paiement</label>
            <select value={paymentMethod} onChange={e => setPaymentMethod(e.target.value)}>
              <option value="card">Carte</option>
              <option value="cash">Espèces</option>
            </select>
          </div>

          <div className="form-group">
            <label>Marchand</label>
            <select value={merchantId} onChange={e => handleMerchantChange(e.target.value)}>
              <option value="">— Aucun —</option>
              {merchants.map(m => (
                <option key={m.id} value={m.id}>
                  {m.name}{m.category_name ? ` (${m.category_name})` : ''}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Libellé</label>
            <input
              type="text"
              placeholder="Ex : Courses Leclerc"
              value={raw_label}
              onChange={e => setRawLabel(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Montant (€)</label>
            <input
              type="number"
              step="0.01"
              min="0"
              placeholder="0,00"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Date</label>
            <input
              type="date"
              value={date}
              onChange={e => setDate(e.target.value)}
              required
            />
          </div>

          {paymentMethod === 'cash' && (
            <div className="form-group">
              <label>Compte cash</label>
              <input
                type="number"
                value={cashAccountId}
                onChange={e => setCashAccountId(e.target.value)}
                required
              />
            </div>
          )}

        </div>

        <div style={{ marginTop: 16, display: "flex", gap: 10 }}>
          <button type="submit" className="btn btn-primary">
            Ajouter la transaction
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => setShowWithdrawal(!showWithdrawal)}
          >
            💵 Retrait espèces
          </button>
        </div>

      </form>

      {/* RETRAIT */}
      {showWithdrawal && (
        <form
          onSubmit={handleWithdrawal}
          style={{
            marginTop: 20,
            padding: "16px 20px",
            background: "var(--border-soft)",
            borderRadius: "var(--radius-md)",
            border: "1px solid var(--border)"
          }}
        >
          <h3 style={{ marginTop: 0 }}>Retrait espèces</h3>

          <div className="form-grid">
            <div className="form-group">
              <label>Compte bancaire</label>
              <input type="number" value={bankAccountId} onChange={e => setBankAccountId(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Compte cash</label>
              <input type="number" value={cashAccountId} onChange={e => setCashAccountId(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Montant (€)</label>
              <input type="number" step="0.01" min="0" placeholder="0,00" value={amount} onChange={e => setAmount(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Date</label>
              <input type="date" value={date} onChange={e => setDate(e.target.value)} required />
            </div>
            <div className="form-group form-full">
              <label>Libellé</label>
              <input type="text" placeholder="ATM Withdrawal" value={raw_label} onChange={e => setRawLabel(e.target.value)} />
            </div>
          </div>

          <div style={{ marginTop: 14 }}>
            <button type="submit" className="btn btn-primary">Valider le retrait</button>
          </div>

        </form>
      )}

    </div>
  );
}
